/* eslint-disable import/prefer-default-export */
import getVideoId from 'get-video-id';

export const generateVideoEmbed = (source) => {
  let player = '';
  if (source.includes('youtube')) {
    const sourceData = getVideoId(source);
    player = `<iframe class='embed__video' src='https://www.youtube.com/embed/${sourceData.id}' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>`;
  } else if (source.includes('vimeo')) {
    const sourceData = getVideoId(source);
    player = `<iframe class='embed__video' src='https://player.vimeo.com/video/${sourceData.id}' allow='autoplay; fullscreen' title='Vimeo video' allowfullscreen=''></iframe>`;
  } else {
    // attempt to build a player assuming mp4 that could fit in a standard html5 player
    player = `<video class='video-player' controls src=${source} />`;
  }
  return player;
};
